import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

const CollectionCell = ({ rowData, onCollectionClick, isDisabled }) => {
  const { collection } = rowData;

  if (!collection || !collection.id) return null;

  return (
    <OverflowTooltip
      autoTipOnEllipsis
      style={{
        zIndex: 9999,
      }}
      variant={OverflowTooltip.VARIANTS.LIGHT}
    >
      <LinkButton
        style={{
          color: isDisabled
            ? theme.colors.charcoal500
            : theme.colors.adskBlue500,
        }}
        onClick={(e) => {
          e?.stopPropagation(); // Avoid table row get selected
          onCollectionClick(collection.id);
        }}
      >
        {collection.type !== 'default' ? collection.name : '--'}
      </LinkButton>
    </OverflowTooltip>
  );
};

CollectionCell.propTypes = {
  rowData: PropTypes.shape({
    collection: PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  onCollectionClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default CollectionCell;
